// actions.js
import Api from "../../api/Api";
import { toast } from "react-toastify";
import axios from "axios";
import {
  ADD_RATES_SUCCESS,
  DELETE_RATES_SUCCESS,
  GET_RATES_SUCCESS,
  UPDATE_RATES_SUCCESS,
} from "./actionTypes";

// Add a function to ensure the Rates model includes images when loading
export const loadRates = () => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  const req = Api.get("/rates/get");

  toast.promise(req, {
    pending: "Getting rates...",
    success: {
      render({ data }) {
        // Make sure we're getting the full data including images
        console.log("Rates data received:", data.data.data);

        dispatch({
          payload: { apples: data.data.data, exports: data.data.exports },
          type: GET_RATES_SUCCESS,
        });
        return "Your Data Is Ready";
      },
    },
    error: {
      render({ data }) {
        console.error("Error loading rates:", data);
        return "An error occurred while getting rates";
      },
    },
  });
};

export const addRates = (formData) => (dispatch, getState) => {
  // Create a custom instance for this request
  const apiInstance = axios.create({
    baseURL: Api.defaults.baseURL,
    headers: {
      Authorization: "Bearer " + getState().login.token,
      Accept: "application/json",
      // Don't set Content-Type, it will be set automatically with boundary
    },
  });

  // Log FormData entries for debugging
  console.log("FormData entries for add:");
  for (const pair of formData.entries()) {
    console.log(
      pair[0] +
        ": " +
        (pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1])
    );
  }

  const req = apiInstance.post("/rates/add", formData, {
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      console.log("Upload progress:", percentCompleted);
    },
  });

  return toast.promise(req, {
    pending: "Uploading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: ADD_RATES_SUCCESS,
        });
        return "Rate added successfully";
      },
    },
    error: {
      render({ data }) {
        console.error("Upload error:", data);
        return (
          data?.response?.data?.message ||
          "An error occurred while adding the rate"
        );
      },
    },
  });
};

export const updateRates = (formData) => (dispatch, getState) => {
  // Create a custom instance for this request
  const apiInstance = axios.create({
    baseURL: Api.defaults.baseURL,
    headers: {
      Authorization: "Bearer " + getState().login.token,
      Accept: "application/json",
      // Don't set Content-Type, it will be set automatically with boundary
    },
  });

  // Log FormData contents for debugging
  console.log("FormData entries for update:");
  for (const pair of formData.entries()) {
    console.log(
      pair[0] +
        ": " +
        (pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1])
    );
  }

  const req = apiInstance.post("/rates/update", formData, {
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      console.log("Upload progress:", percentCompleted);
    },
  });

  return toast.promise(req, {
    pending: "Uploading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: UPDATE_RATES_SUCCESS,
        });
        return "Rate updated successfully";
      },
    },
    error: {
      render({ data }) {
        console.error("Update error:", data);
        return (
          data?.response?.data?.message ||
          "An error occurred while updating your rate"
        );
      },
    },
  });
};

export const deleteRates = (data) => (dispatch, getState) => {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + getState().login.token;
  const req = Api.post("/rates/delete", data);

  toast.promise(req, {
    pending: "Loading...",
    success: {
      render({ data }) {
        dispatch({
          payload: data.data.data,
          type: DELETE_RATES_SUCCESS,
        });
        return "Rate deleted successfully";
      },
    },
    error: {
      render({ data }) {
        console.log(data);
        return "An error occurred while deleting your rate";
      },
    },
  });
};
